<template>
  <layout
      :title="$t(`code.title`)"
      :desc="$t(`code.desc`)"
      :links="[{ href: `Login`, label: $t(`login.title`) }, { href: `AnswerWithCode`, label: $t(`login.answerCode`) }]"
  >
    <div class="alert alert-danger" role="alert" v-if="invalid">
      {{$t(`code.invalid`)}}
    </div>
    <form @submit.prevent="send">
      <input class="form-control" type="text" v-model="code" :placeholder="$t(`code.code`)" required :disabled="loading">
      <div class="form-button full-width">
        <button id="submit" type="submit" class="ibtn btn-forget" :disabled="loading" style="width: 100%;">{{$t(`code.send`)}}</button>
      </div>
    </form>
    <div class="other-links">
      <router-link :to="{ name: `Login` }">{{$t(`code.backToLogin`)}}</router-link>
    </div>
  </layout>
</template>

<script>
import Layout from './Layout';

export default {
  name: "AnswerWithCode",
  components: {
    Layout,
  },
  data: () => ({
    code: ``,
    loading: false,
    invalid: false,
  }),
  methods: {
    async send () {
      this.loading = true;
      this.invalid = false;
      if (await this.$store.dispatch(`answerWithCode`, this.code)) {
        return window.location.href = `/sc/${this.code}`;
      }
      this.invalid = true;
      this.loading = false;
    },
  },
};
</script>

<style scoped>

</style>
